import { t } from "../i18n";

interface Props {
  dadName: string;
  onCheckout: () => void;
  onRestart: () => void;
}

export function PaywallStep({ dadName, onCheckout, onRestart }: Props) {
  return (
    <div className="card reading-card">
      <h2 className="archetype">{t("paywall.title")}</h2>
      <p className="reasoning">{t("paywall.body", { name: dadName })}</p>
      <button className="btn btn-primary" onClick={onCheckout}>
        {t("paywall.checkout")}
      </button>
      <button className="text-link" onClick={onRestart} type="button">
        {t("paywall.restart")}
      </button>
    </div>
  );
}
